// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal styles */
.XceWIr {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.DL_ffb {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.WsprVn {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border-radius: 0;
  border: none;
  background-color: var(--surface-neutral-white);
  display: flex;
  flex-direction: column;
}

.heEm45 {
  background-color: var(--overlay-dark, rgba(0, 0, 0, 0.5));
}

.sibRFK {
  padding: var(--spacing-3) var(--spacing-3) 0;
  border: none;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  flex-direction: column;
}

.P9G2h_ {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: var(--spacing-1);
  margin-bottom: var(--spacing-3);
}

.qTvg6J {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.X6pC_v {
  background: none;
  border: none;
  padding: var(--spacing-0-5);
  width: var(--icon-size-m);
  height: var(--icon-size-m);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: calc(-1 * var(--spacing-0-5));
}

.X6pC_v img {
  width: 16px;
  height: 16px;
}

.dfmLJH {
  padding: var(--spacing-3);
  overflow-y: auto;
  min-height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Tabs */
.eVj9oC {
  display: flex;
  width: 100%;
  border-bottom: 1px solid var(--bs-gray-200);
  margin-bottom: var(--spacing-3);
}

.H8QFe3 {
  flex: 1;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-1);
  background: none;
  border: none;
  padding: var(--spacing-2) 0;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-md);
  border-bottom: var(--border-width-s, 2px) solid transparent;
  transition: all 0.2s ease;
}

.H8QFe3:hover {
  color: var(--text-neutral-dark);
  border-bottom-color: var(--text-neutral-stronger);
}

.UZMQR7:hover {
  color: var(--text-primary-medium);
  border-bottom-color: var(--text-primary-medium);
}

.UZMQR7 {
  color: var(--text-primary-medium);
  border-bottom-color: var(--text-primary-medium);
}

.nTQZS8 {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.Mw4aro {
  color: var(--surface-primary-medium);
}

.zLpAZv {
  color: var(--text-neutral-dark);
}

/* Search Section */
.n7xybR {
  margin-bottom: var(--spacing-3);
  width: 100%;
}

.tyRVlr {
  flex: 1;
  min-width: 250px;
  width: 100%;
}

.E2N4ly {
  color: var(--icon-neutral-medium);
  width: 16px;
  height: 16px;
}

/* Network Content */
.eW3U84 {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 80%;
}

/* Feedback states */
.UtozGW {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: var(--spacing-4);
  text-align: center;
}

.W87KZv {
  background: var(--surface-primary-subtle);
  border-radius: 50%;
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-3);
}

.t59bJb {
  background: var(--surface-primary-subtle);
  border-radius: 50%;
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-3);
}

.qTLG9d {
  width: 32px;
  height: 32px;
  color: var(--icon-primary-medium);
}

.Oa4pos {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-1);
  margin-top: 0;
}

.CafW18 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-stronger);
  margin-bottom: 0;
}

.JdhbnN {
  background-color: var(--surface-primary-medium);
  color: var(--bs-white);
  border: none;
  border-radius: var(--radius-s);
  padding: var(--spacing-1-5) var(--spacing-3);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;
}

.JdhbnN:hover {
  background-color: var(--surface-primary-strong);
  opacity: 0.9;
  transform: translateY(-1px);
}

/* Empty state */
.N0L5Tp {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-4);
  text-align: center;
  flex: 1;
}

.IP9lCG {
  width: 72px;
  height: 72px;
  background: var(--surface-primary-subtle);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-3);
  font-size: 32px;
}

.dvFGYj {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-1);
  margin-top: 0;
}

.PykaTw {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-stronger);
  margin-bottom: var(--spacing-3);
  max-width: 300px;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .DL_ffb {
    max-width: 100vw;
  }

  .eVj9oC {
    flex-direction: row;
    align-items: stretch;
  }

  .H8QFe3 {
    flex: 1;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NetworkPage.module.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,WAAW;EACX,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;EAC9B,2DAA2D;EAC3D,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,4CAA4C;EAC5C,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,OAAO;IACP,kBAAkB;EACpB;AACF","sourcesContent":["/* Modal styles */\n.modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  background-color: var(--surface-neutral-white);\n  display: flex;\n  flex-direction: column;\n}\n\n.backdrop {\n  background-color: var(--overlay-dark, rgba(0, 0, 0, 0.5));\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-3) 0;\n  border: none;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  flex-direction: column;\n}\n\n.modalTitleHeader {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: var(--spacing-1);\n  margin-bottom: var(--spacing-3);\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: var(--spacing-0-5);\n  width: var(--icon-size-m);\n  height: var(--icon-size-m);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin: calc(-1 * var(--spacing-0-5));\n}\n\n.backButton img {\n  width: 16px;\n  height: 16px;\n}\n\n.modalBody {\n  padding: var(--spacing-3);\n  overflow-y: auto;\n  min-height: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Tabs */\n.tabsContainer {\n  display: flex;\n  width: 100%;\n  border-bottom: 1px solid var(--bs-gray-200);\n  margin-bottom: var(--spacing-3);\n}\n\n.tabButton {\n  flex: 1;\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-1);\n  background: none;\n  border: none;\n  padding: var(--spacing-2) 0;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-md);\n  border-bottom: var(--border-width-s, 2px) solid transparent;\n  transition: all 0.2s ease;\n}\n\n.tabButton:hover {\n  color: var(--text-neutral-dark);\n  border-bottom-color: var(--text-neutral-stronger);\n}\n\n.tabButtonActive:hover {\n  color: var(--text-primary-medium);\n  border-bottom-color: var(--text-primary-medium);\n}\n\n.tabButtonActive {\n  color: var(--text-primary-medium);\n  border-bottom-color: var(--text-primary-medium);\n}\n\n.tabIcon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.tabIconActive {\n  color: var(--surface-primary-medium);\n}\n\n.tabIconInactive {\n  color: var(--text-neutral-dark);\n}\n\n/* Search Section */\n.searchSection {\n  margin-bottom: var(--spacing-3);\n  width: 100%;\n}\n\n.searchContainer {\n  flex: 1;\n  min-width: 250px;\n  width: 100%;\n}\n\n.searchIcon {\n  color: var(--icon-neutral-medium);\n  width: 16px;\n  height: 16px;\n}\n\n/* Network Content */\n.networkContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 80%;\n}\n\n/* Feedback states */\n.feedbackContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: var(--spacing-4);\n  text-align: center;\n}\n\n.loadingIconContent {\n  background: var(--surface-primary-subtle);\n  border-radius: 50%;\n  display: flex;\n  height: 72px;\n  width: 72px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: var(--spacing-3);\n}\n\n.permissionIconContainer {\n  background: var(--surface-primary-subtle);\n  border-radius: 50%;\n  display: flex;\n  height: 72px;\n  width: 72px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: var(--spacing-3);\n}\n\n.permissionIcon {\n  width: 32px;\n  height: 32px;\n  color: var(--icon-primary-medium);\n}\n\n.feedbackTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-1);\n  margin-top: 0;\n}\n\n.feedbackText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-stronger);\n  margin-bottom: 0;\n}\n\n.feedbackButton {\n  background-color: var(--surface-primary-medium);\n  color: var(--bs-white);\n  border: none;\n  border-radius: var(--radius-s);\n  padding: var(--spacing-1-5) var(--spacing-3);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 160px;\n}\n\n.feedbackButton:hover {\n  background-color: var(--surface-primary-strong);\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n/* Empty state */\n.emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-4);\n  text-align: center;\n  flex: 1;\n}\n\n.emptyStateIcon {\n  width: 72px;\n  height: 72px;\n  background: var(--surface-primary-subtle);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: var(--spacing-3);\n  font-size: 32px;\n}\n\n.emptyStateTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-1);\n  margin-top: 0;\n}\n\n.emptyStateText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-stronger);\n  margin-bottom: var(--spacing-3);\n  max-width: 300px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .modalDialog {\n    max-width: 100vw;\n  }\n\n  .tabsContainer {\n    flex-direction: row;\n    align-items: stretch;\n  }\n\n  .tabButton {\n    flex: 1;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `XceWIr`,
	"modalDialog": `DL_ffb`,
	"modalContent": `WsprVn`,
	"backdrop": `heEm45`,
	"modalHeader": `sibRFK`,
	"modalTitleHeader": `P9G2h_`,
	"modalTitle": `qTvg6J`,
	"backButton": `X6pC_v`,
	"modalBody": `dfmLJH`,
	"tabsContainer": `eVj9oC`,
	"tabButton": `H8QFe3`,
	"tabButtonActive": `UZMQR7`,
	"tabIcon": `nTQZS8`,
	"tabIconActive": `Mw4aro`,
	"tabIconInactive": `zLpAZv`,
	"searchSection": `n7xybR`,
	"searchContainer": `tyRVlr`,
	"searchIcon": `E2N4ly`,
	"networkContent": `eW3U84`,
	"feedbackContainer": `UtozGW`,
	"loadingIconContent": `W87KZv`,
	"permissionIconContainer": `t59bJb`,
	"permissionIcon": `qTLG9d`,
	"feedbackTitle": `Oa4pos`,
	"feedbackText": `CafW18`,
	"feedbackButton": `JdhbnN`,
	"emptyState": `N0L5Tp`,
	"emptyStateIcon": `IP9lCG`,
	"emptyStateTitle": `dvFGYj`,
	"emptyStateText": `PykaTw`
};
module.exports = ___CSS_LOADER_EXPORT___;
